module.exports = __webpack_public_path__ + "img/truffle.9886d4e3.png";